module.exports = __webpack_public_path__ + "img/ban.4c72c88b.svg";